/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_ContributeInputs */



/**
* | output |
* | --- |
* | "Contribute" |
*
* @param {Layout_Header_ContributeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_contribute = /** @type {((inputs?: Layout_Header_ContributeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_ContributeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitmachen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contribuer")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("贡献")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("投稿")
	if (locale === "ko") return /** @type {LocalizedString} */ ("기여하기")
	return /** @type {LocalizedString} */ ("Contribute")
});